import React, { PureComponent } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import UploadInput from './UploadInput';

const renderFieldTextArea = ({
  input,
  refLineNumber,
  refTextArea,
  onScroll
}) => {
  const lines = input.value.split('\n');

  return (
    <div className="textarea-wrapper">
      <div className="line-nums" ref={refLineNumber}>
        {Array.from(lines, (x, i) => i + 1).map((item) => (
          <span key={item}>{item}.</span>
        ))}
      </div>
      <textarea
        ref={refTextArea}
        onScroll={onScroll}
        rows="6"
        {...input}
        className="styleFieldArea"
      />
    </div>
  );
};

class PodcastValidateForm extends PureComponent {
  refLineNumber = React.createRef();
  refTextArea = React.createRef();

  onScroll = () => {
    const scrollTop = this.refTextArea.current.scrollTop;
    this.refLineNumber.current.scrollTop = scrollTop;
  };

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      showClose,
      onClose
    } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name="rssFeed"
          component={renderFieldTextArea}
          label="URL Feeds"
          onScroll={this.onScroll}
          refLineNumber={this.refLineNumber}
          refTextArea={this.refTextArea}
        />
        <div className="validate-buttons">
          <button
            className="btn btn-tags"
            type="submit"
            disabled={submitting || pristine}
          >
            Validate
          </button>
          {showClose && (
            <button
              type="button"
              className="btn btn-tags close-validate"
              onClick={onClose}
            >
              Hide
            </button>
          )}
        </div>
      </form>
    );
  }
}

class ValidationForm extends PureComponent {
  constructor() {
    super();

    this.state = {
      file: null,
      dragging: false
    };
  }

  onFileSelected = (e) => {
    const file =
      e.target.files && e.target.files.length ? e.target.files[0] : null;
    this.setState({ file });
  };

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ dragging: false });

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      this.setState({ file });
      e.dataTransfer.clearData();
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ dragging: true });
    }
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ dragging: false });
  };

  handleSubmit = () => {
    this.props.onSubmitUpload(this.state.file);
  };

  render() {
    const { onSubmit, showClose, onClose } = this.props;

    return (
      <div className="podcast-form">
        <h4>Validate podcasts</h4>
        <Tabs defaultActiveKey="rssFeed" id="uncontrolled-tab-example">
          <Tab eventKey="rssFeed" title="RSS Feeds">
            <PodcastValidateForm
              onSubmit={onSubmit}
              showClose={showClose}
              onClose={onClose}
            />
          </Tab>
          <Tab eventKey="opml" title="OPML file">
            <>
              <UploadInput
                file={this.state.file}
                onDrop={this.handleDrop}
                onDragOver={this.handleDragOver}
                onDragEnter={this.handleDragEnter}
                onDragLeave={this.handleDragLeave}
                onFileSelected={this.onFileSelected}
              />
              <div className="validate-buttons">
                <button
                  className="btn btn-tags"
                  type="button"
                  onClick={this.handleSubmit}
                  disabled={!this.state.file}
                >
                  Validate
                </button>
                {showClose && (
                  <button
                    type="button"
                    className="btn btn-tags close-validate"
                    onClick={onClose}
                  >
                    Hide
                  </button>
                )}
              </div>
            </>
          </Tab>
        </Tabs>
      </div>
    );
  }
}

PodcastValidateForm = reduxForm({
  form: 'podcastValidateForm'
})(PodcastValidateForm);

export default ValidationForm;
